// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2Ih-r","header":"styles__header___3NtYy","tab":"styles__tab___3mEdW","tab_link":"styles__tab_link___26P2U","tab_link_checked":"styles__tab_link_checked___1Aniy"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/ClientDetails/styles.css
// module id = 3141
// module chunks = 0